<template>
  <AdminLogin v-if="!isAdminLoggedIn"/>
  <div class="dflexr-jcc admin-mainview" v-if="isAdminLoggedIn" >
    <div class="dflexc-jcs" id="table-select-col">
      <nav class="tables-panel">
        <BtnCommon btnLabel="User" styleclass="TableSelect"
                   @clicked="selectTable" />
        <BtnCommon btnLabel="Topics" styleclass="TableSelect"
                   @clicked="selectTable" />
        <BtnCommon btnLabel="Blog" styleclass="TableSelect"
                   @clicked="selectTable" />
      </nav>

      <nav class="hedge-assist-panel">
        <BtnCommon btnLabel="IW-Population" styleclass="TableSelect"
                   @clicked="selectTable" />
      </nav>
    </div>
    <div class="dflexc-jcs" id="table-view-col" >
      <UserTableView v-if="activeTable === 'User'" />
      <TopicsTableView v-if="activeTable === 'Topics'" />
      <BlogPostsTableView v-if="activeTable === 'Blog'" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/admin";
</style>

<script setup>
import AdminLogin from "@/components/dialogs/AdminLogin.vue";
import {computed, onBeforeMount, ref} from "vue";

import BtnCommon from "@/components/common/btn-common.vue";
import UserTableView from "@/components/admin/user-table-view.vue";
import TopicsTableView from "@/components/admin/topics-table-view.vue";
import BlogPostsTableView from "@/components/admin/blog-posts-table-view.vue";

const activeTable = ref('User')

const isAdminLoggedIn = computed(() => {
  console.log('admin logged in:', window.novasectorapp.admin_logged_in)
  return window.novasectorapp.admin_logged_in
})

onBeforeMount(() => {
  const user = JSON.parse(localStorage.getItem('novasector-user'))
  if(user === null)
    return
  window.novasectorapp.admin_logged_in = window.novasectorapp.adminLevel(user.level)
})

function selectTable(table) {
  activeTable.value = table
}
</script>
